// Must stay first: sets the language (from the URL) that i18n starts in.
import { lang, stylesReady, fontsReady } from "./shared/seo/boot";
import React from "react";
import ReactDOM from "react-dom";
import "./shared/i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import AuthProvider from "./shared/context/AuthContext";
import ErrorBoundary from "./shared/components/ErrorBoundary";

// The boot splash in index.html covers #root (and its server-rendered markup,
// which is there for crawlers) until React has mounted; then it fades out.
function hideBootSplash() {
  document.documentElement.classList.remove("avc-booting");
  const splash = document.getElementById("avc-boot");
  if (!splash) return;
  splash.classList.add("is-leaving");
  setTimeout(() => splash.remove(), 300);
}

// Waiting only for the direction stylesheet and the font (capped; not
// window "load", which also waits for ads and analytics) keeps the splash
// short, and the page does not reflow once it is shown.
Promise.all([stylesReady, fontsReady(lang)]).then(() => {
  ReactDOM.render(
    <React.StrictMode>
      <ErrorBoundary>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ErrorBoundary>
    </React.StrictMode>,
    document.getElementById("root"),
    // After the first commit: wait one frame so the page has painted under the splash.
    () => requestAnimationFrame(hideBootSplash)
  );
});

reportWebVitals();
